module.exports = __webpack_public_path__ + "static/img/follow.0f26cdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/follow.png
// module id = ptEB
// module chunks = 1